"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const Slide_vue_1 = tslib_1.__importDefault(require("../Slide.vue"));
exports.default = vue_1.default.extend({
    name: 'converted-user',
    props: {},
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    computed: {},
    methods: {
        linkForCreateNewPassword() {
            const link = `${this.$store.state.configuration.baseUrl}ForgotPassword`;
            return link;
        },
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        instructions() {
            const bankName = this.$store.state.configuration.bankName;
            return this.getSiteText('ConvertedUser.Text', bankName);
        },
    },
    components: {
        IsotopeSlide: Slide_vue_1.default,
    },
});
